import { ThemeUICSSObject } from '@apia/theme';
import dataGrid from './dataGrid';
import tree from './tree';
import text from './text';
import scheduler from './scheduler';
import uploader from './uploader';
import captcha from './captcha';
import editor from './editor';
import image from './image';
import link from './link';
import title from './title';
import radio from './radio';
/* IMPORT HERE */

const fields: ThemeUICSSObject = {
  dataGrid,
  uploader,
  tree,
  text,
  scheduler,
  captcha,
  editor,
  image,
  link,
  title,
  radio,
  /* PREPEND HERE */
};

export default fields;
